export const READ_WASTE = 'COMPANY_READ_WASTE';
export const APPROVE_WASTE = 'COMPANY_APPROVE_WASTE';
export const READ_WASTE_LIST = 'COMPANY_READ_WASTE_LIST';
export const CREATE_WASTE_WITH_VIOLATIONS = 'COMPANY_CREATE_WASTE_WITH_VIOLATIONS';
export const CREATE_WASTE = 'COMPANY_CREATE_WASTE';
export const REJECT_WASTE = 'COMPANY_REJECT_WASTE';

export const WASTE_STATUSES = {
  REGISTERED: 'REGISTERED',
  APPROVED: 'APPROVED',
  PROCESSED: 'PROCESSED',
  REJECTED: 'REJECTED',
  DRAFT: 'DRAFT',
  CANCELED: 'CANCELED',
} as const;

export const WASTE_TYPE = {
  LABOR_COST_WASTE: 'LABOR',
  OTHER_EXPENSES_WASTE: 'OTHER',
};

export const WASTE_TYPE_OPTIONS = {
  [WASTE_TYPE.LABOR_COST_WASTE]: 'Labor',
  [WASTE_TYPE.OTHER_EXPENSES_WASTE]: 'Other',
} as const;

export const WASTE_REPORTING_METHOD = {
  BY_TICKET_IDS: 'BY_TICKET_IDS',
  BY_EMPLOYEE_AND_TICKET_IDS: 'BY_EMPLOYEE_AND_TICKET_IDS',
  BY_PROJECT_PERIOD: 'BY_PROJECT_AND_PERIOD',
};

export const WASTE_REPORTING_METHOD_OPTIONS = {
  [WASTE_REPORTING_METHOD.BY_EMPLOYEE_AND_TICKET_IDS]: 'By Employee and Ticket ID (s)',
  [WASTE_REPORTING_METHOD.BY_PROJECT_PERIOD]: 'By Project and Period',
  [WASTE_REPORTING_METHOD.BY_TICKET_IDS]: 'By Ticket ID (s)',
} as const;

export const WASTE_STATUSES_OPTIONS = {
  [WASTE_STATUSES.REGISTERED]: 'Registered',
  [WASTE_STATUSES.APPROVED]: 'Approved',
  [WASTE_STATUSES.PROCESSED]: 'Processed',
  [WASTE_STATUSES.REJECTED]: 'Rejected',
  [WASTE_STATUSES.DRAFT]: 'Draft',
  [WASTE_STATUSES.CANCELED]: 'Canceled',
} as const;
